"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsletterDialog = NewsletterDialog;
var _DialogActions2 = _interopRequireDefault(require("@mui/material/DialogActions"));
var _Dialog2 = _interopRequireDefault(require("@mui/material/Dialog"));
var _Button2 = _interopRequireDefault(require("@mui/material/Button"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _FormControl2 = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormControlLabel2 = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Checkbox2 = _interopRequireDefault(require("@mui/material/Checkbox"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _formik = require("formik");
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _newsletter = _interopRequireDefault(require("../../assets/images/newsletter.svg"));
var _services = require("../../services");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function NewsletterDialog({
  user,
  onClose,
  ...props
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    isSubmitting,
    values,
    setValues,
    handleChange,
    handleSubmit
  } = (0, _formik.useFormik)({
    initialValues: {
      receiveActivityEmails: false,
      receiveNewsletter: false
    },
    enableReinitialize: true,
    onSubmit
  });
  (0, _react.useEffect)(() => {
    if (props.open) {
      const {
        options: {
          receiveEmails,
          receiveNewsletter
        }
      } = user;
      setValues({
        receiveActivityEmails: receiveEmails,
        receiveNewsletter
      });
    }
  }, [props.open]);
  async function onSubmit({
    receiveActivityEmails,
    receiveNewsletter
  }, {
    setSubmitting
  }) {
    setSubmitting(true);
    try {
      const options = await _services.UserService.updateUserOptions(user.id, {
        receive_email: receiveActivityEmails,
        receive_newsletter: receiveNewsletter
      });
      onClose(options);
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.newsletter_dialog.not_updated'));
    }
    setSubmitting(false);
  }
  return /*#__PURE__*/_react.default.createElement(_Dialog2.default, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => onClose(),
    scroll: "paper",
    slotProps: {
      paper: {
        sx: {
          borderRadius: 4
        }
      }
    }
  }, props), /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(StyledLogo, {
    alt: "Logo newsletter",
    src: _newsletter.default
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    gutterBottom: true,
    color: "primary",
    variant: "h5"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.newsletter_dialog.title"
  })), /*#__PURE__*/_react.default.createElement(StyledRow, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.newsletter_dialog.activity_emails_description"
  })), /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    component: "fieldset",
    disabled: isSubmitting
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel2.default, {
    control: /*#__PURE__*/_react.default.createElement(_Checkbox2.default, {
      color: "primary",
      name: "receiveActivityEmails",
      onChange: handleChange,
      value: values.receiveActivityEmails
    }),
    label: /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      variant: "caption"
    }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.newsletter_dialog.receive_activity_emails"
    }))
  }))), /*#__PURE__*/_react.default.createElement(StyledRow, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.newsletter_dialog.newsletter_description"
  })), /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    component: "fieldset",
    disabled: isSubmitting
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel2.default, {
    control: /*#__PURE__*/_react.default.createElement(_Checkbox2.default, {
      color: "primary",
      name: "receiveNewsletter",
      onChange: handleChange,
      value: values.receiveNewsletter
    }),
    label: /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      variant: "caption"
    }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.newsletter_dialog.receive_newsletter"
    }))
  }))), /*#__PURE__*/_react.default.createElement(StyledRow, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.newsletter_dialog.description"
  })))), /*#__PURE__*/_react.default.createElement(StyledDialogActions, null, /*#__PURE__*/_react.default.createElement(_Button2.default, {
    disabled: isSubmitting,
    onClick: () => onClose(),
    size: "medium",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.close"
  })), /*#__PURE__*/_react.default.createElement(_Button2.default, {
    color: "primary",
    disabled: isSubmitting,
    size: "medium",
    type: "submit",
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.confirm"
  })))));
}
const ContentWrapper = _styledComponents.styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px;
`;
const StyledLogo = _styledComponents.styled.img`
  align-self: center;
  margin: 16px 0;
  width: 120px;
`;
const StyledRow = _styledComponents.styled.div`
  margin-top: 16px;
`;
const StyledDialogActions = (0, _styledComponents.styled)(_DialogActions2.default)`
  justify-content: flex-end;
`;